export default __webpack_public_path__ + "static/media/IoT-logo-color.fc20106e.png";